import { CLASSES } from "@/scripts/helpers/constants";
import passwordValidator from "password-validator";
import { handleParsleyActions } from "@/scripts/helpers/parsleyValidation";
import { initLoader, hideLoader } from "@/modules/loader/loader";
import {
  onRegistration,
  onTrialPurchased,
  onRegularFreeTrialActions
} from "@/scripts/helpers/googleAnalyticsEvents";
import Cookies from "js-cookie";
import { getDomainName } from "@/scripts/helpers/getUrlParams";
import axios from "axios";

export const freeTrialForm = () => {
  if ($("#modal-registration").length) {
    const freeTrialForm = document.querySelector("#form-free-trial");
    const fieldEmail = document.querySelector(".js-free-trial-mail");
    const fieldPassword = document.querySelector(".js-free-trial-pass");
    const passwordTooltip = document.querySelector(".helper-tooltip");
    const inputCaptcha = document.querySelector("#capthca-tokens");
    const submit = document.querySelector("#form-free-trial .form-submit");
    const passwordStrength = document.querySelector(".password-strength");
    const captchaKeyV2 = inputCaptcha.getAttribute("data-v2-token");
    const captchaKeyV3 = inputCaptcha.getAttribute("data-v3-token");
    let captchaV2Active = false;
    let captchaV3Active = true;
    let captchaV2Token;
    const domain = getDomainName();

    handleParsleyActions();

    const schema = new passwordValidator();
    const emailBeforeDoggie = fieldEmail.value.substr(
      0,
      fieldEmail.value.indexOf("@")
    );
    schema
      .is()
      .min(6)
      .has()
      .not()
      .spaces()
      .has()
      .not()
      .oneOf([fieldEmail.value, emailBeforeDoggie]);

    const handlePassIcon = () => {
      const trigger = $(".js-show-pass");

      if (trigger.length) {
        trigger.on("click", function() {
          $(this)
            .parents(".form__item")
            .find(".form-control--pass")
            .attr("type", (index, attr) =>
              attr === "password" ? "text" : "password"
            );
        });
      }
    };

    handlePassIcon();

    $("[data-micromodal-trigger='modal-registration']").click(function(e) {
      e.preventDefault();

      onRegularFreeTrialActions("Email", "Start");
    });

    $("#modal-registration .modal__close").click(function(e) {
      e.preventDefault();

      freeTrialForm.reset();

      $("#form-free-trial")
        .parsley()
        .reset();

      submit.removeAttribute("disabled");
    });

    const getCaptchaV2token = response => {
      captchaV2Token = response;
      if ($("#reCaptcha").next(".parsley-errors-list").length) {
        $("#reCaptcha")
          .next(".parsley-errors-list")
          .hide();
        submit.removeAttribute("disabled");
      }
    };

    const initRecaptchaV2 = () => {
      const recaptchaWrapper = document.querySelector(".recaptcha-area");

      grecaptcha.ready(() => {
        grecaptcha.render("reCaptcha", {
          sitekey: captchaKeyV2,
          callback: getCaptchaV2token
        });
      });

      recaptchaWrapper.classList.remove(CLASSES.IS_HIDDEN);
      recaptchaWrapper.classList.add(CLASSES.IS_VISIBLE);
      captchaV2Active = true;
      captchaV3Active = false;
    };

    const initRecaptchaV2Script = () => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://www.google.com/recaptcha/api.js?render=explicit";
      script.setAttribute("async", "async");
      script.setAttribute("defer", "defer");
      document.body.appendChild(script);
    };

    const initRecaptchaV3Script = () => {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.src = `https://www.google.com/recaptcha/api.js?render=${captchaKeyV3}`;
      script.setAttribute("async", "async");
      script.setAttribute("defer", "defer");
      document.body.appendChild(script);
    };

    initRecaptchaV3Script();

    const pathSnSeats =
      process.env.NODE_ENV === "production"
        ? "https://snseats.signnow.com/"
        : "https://sn-payments-front-bravo.signnow-dev.xyz/";

    const sendUserData = (token = undefined, version = undefined) => {
      $.post({
        url: freeTrialForm.getAttribute("action"),
        data: {
          email: fieldEmail.value,
          password: fieldPassword.value,
          recaptcha_token: token,
          recaptcha_version: version
        },
        dataType: "json",
        headers: {
          "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr("content")
        },
        beforeSend() {
          initLoader($("#modal-registration .loader"));
        },
        success(response) {
          onRegistration();
          onTrialPurchased();
          onRegularFreeTrialActions("Email", "Sign-up");
          Cookies.set("SN_SIGNUP_USER_EMAIL", fieldEmail.value, {
            expires: 30,
            domain: domain
          });

          window.location.href = `${pathSnSeats}purchase/free_trial_thank_you`;
        },
        error(response) {
          hideLoader();

          onRegularFreeTrialActions("Email", "Error");

          if (
            response.status === 400 &&
            response.responseJSON.message === "unverified_email"
          ) {
            submit.removeAttribute("disabled");
            const emailField = $("#modal-registration .form-control--email");
            emailField.parsley().reset();

            emailField.parsley().addError("myError", {
              message:
                "Please check your email to verify your account. You can log in <a href='https://app.signnow.com/' target='_blank' class='link'>here</a> to upgrade your subscription"
            });
          }

          if (
            response.status === 400 &&
            response.responseJSON.message === "User with email exists"
          ) {
            submit.removeAttribute("disabled");
            const emailField = $("#modal-registration .form-control--email");
            emailField.parsley().reset();

            emailField.parsley().addError("myError", {
              message:
                "User with email exists. You can log in <a href='https://app.signnow.com/' target='_blank' class='link'>here</a>"
            });
          }

          if (response.status === 419) {
            initRecaptchaV2Script();
            initRecaptchaV2();
            submit.removeAttribute("disabled");
          }
        }
      });
    };

    const formSubmit = () => {
      freeTrialForm.addEventListener("submit", function(e) {
        e.preventDefault();

        function isCaptchaChecked() {
          return grecaptcha && grecaptcha.getResponse().length !== 0;
        }

        if (captchaV2Active) {
          if (isCaptchaChecked()) {
            console.log("V2 checked");
          } else {
            console.log("V2 not checked");
            $("#reCaptcha")
              .parsley()
              .addError("myError", {
                message: "Please verify reCAPTCHA"
              });
            return false;
          }
        }
        const trimedValue = fieldPassword.value.trim();

        fieldPassword.value = trimedValue;

        if (schema.validate(trimedValue)) {
          if (captchaV3Active) {
            // send v3 token
            grecaptcha.ready(function() {
              grecaptcha
                .execute(captchaKeyV3, {
                  action: "submit"
                })
                .then(function(token) {
                  sendUserData(token, 3);
                });
            });
          }

          if (captchaV2Active) {
            // send v2 token
            grecaptcha.ready(function() {
              sendUserData(captchaV2Token, 2);
            });
          }

          $(".js-free-trial-pass")
            .parsley()
            .reset();

          return false;
        } else {
          $(".js-free-trial-pass")
            .parsley()
            .reset();
          document.querySelectorAll(".form-submit").forEach(button => {
            button.removeAttribute("disabled");
          });
          fieldPassword.focus();
          if (
            schema.validate(fieldPassword.value, { list: true })[0] === "spaces"
          ) {
            $(".js-free-trial-pass")
              .parsley()
              .addError("myError", {
                message: "Please enter your password without spaces"
              });
          } else {
            $(".js-free-trial-pass")
              .parsley()
              .addError("myError", { message: "Oh, needs some tweaking" });
          }
        }
      });
    };

    if (document.readyState == "complete") {
      formSubmit();
    } else {
      document.onreadystatechange = function() {
        if (document.readyState === "complete") {
          formSubmit();
        }
      };
    }
  }
};

export const socialAuth = () => {
  $(".js-sign-button").click(function(e) {
    e.preventDefault();

    let facebook = null;
    let google = null;
    let microsoft = null;
    const pathDomain =
      process.env.NODE_ENV === "production"
        ? ".signnow.com"
        : ".signnow-dev.xyz";

    Cookies.remove("XSRF-TOKEN", { secure: false, domain: `${pathDomain}` });

    if (
      $(this)
        .find("span")
        .text() === "Facebook"
    ) {
      facebook = "facebook";
      onRegularFreeTrialActions("Facebook", "Start");
    } else if (
      $(this)
        .find("span")
        .text() === "Google"
    ) {
      google = "google";
      onRegularFreeTrialActions("Google", "Start");
    } else {
      microsoft = "microsoft";
      onRegularFreeTrialActions("Microsoft", "Start");
    }

    const provider = facebook || google || microsoft;

    const getCookie = name => {
      const prefix = name + "=";
      let begin = document.cookie.indexOf("; " + prefix);
      let end = null;

      if (begin === -1) {
        begin = document.cookie.indexOf(prefix);
        if (begin != 0) return null;
      } else {
        begin += 2;
        end = document.cookie.indexOf(";", begin);
        if (end === -1) end = document.cookie.length;
      }

      return decodeURI(document.cookie.substring(begin + prefix.length, end));
    };

    const generateXSRFToken = () => {
      const domain = getDomainName();
      const currentDate = new Date().getTime();
      const string = currentDate.toString();
      const length = string.length;

      let i = 0;
      let state = 0;

      if (length > 0) {
        while (i < length) {
          state = ((state << 5) - state + string.charCodeAt(i++)) | 0;
        }
        state = Math.abs(state);
      }

      state = state.toString();

      Cookies.set("SN_SOCIAL_AUTH_XSRF_TOKEN", state, {
        expires: 30,
        domain: domain
      });

      return state;
    };

    const state = getCookie("SN_SOCIAL_AUTH_XSRF_TOKEN") || generateXSRFToken();
    const path =
      process.env.NODE_ENV === "production"
        ? "https://app.signnow.com/auth/v1"
        : "https://app3.signnow-dev.xyz/auth/v1";

    axios
      .get(`${path}/socialite/${provider}/link?state=${state}`, {
        withCredentials: true
      })
      .then(res => {
        initLoader($(".loader"));
        setTimeout(() => {
          window.location.href = res.data.link;
        }, 3000);
      })
      .catch(error => {
        console.error(error);
      });
  });
};
